import * as yup from 'yup';
import { validateCifNif, validateSS, validateNifNIE } from './utils/validatorFunctions';


yup.addMethod(yup.string, 'isValidCifNif', function (message = 'El CIF/NIF no es válido') {
    return this.test('valid-cif-nif', message, function (value) {
        if (value !== undefined && value !== null && value.length > 0) {
            return validateCifNif(value);
        }
        return true;
    });
});

yup.addMethod(yup.string, 'isValidNifNIE', function (message = 'El NIF/NIE no es válido') {
    return this.test('valid-nif-nie', message, function (value) {
        if (value !== undefined && value !== null && value.length > 0) {
            return validateNifNIE(value);
        }
        return true;
    });
});

yup.addMethod(yup.string, 'isValidSS', function (message = 'El número de la SS no es válido') {
    return this.test('valid-ss', message, function (value) {
        if (value !== undefined && value !== null && value.length > 0) {
            return validateSS(value);
        }
        return true;
    });
});

export default yup;